// extracted by mini-css-extract-plugin
export var formContainer = "_cj-0";
export var message = "_cj-1";